import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BackgroundHeaderComponent} from '../background/background.component';
import {HeaderWrapperComponent} from './header-wrapper.component';
import {MediaPictureModule} from '@shopping-angular-components/media-picture';
import {TagTextModule} from '../tag-text/tag-text.module';
import {SboxModule} from '../sbox/sbox.module';
import {MainTitleModule} from '../main-title/main-title.module';
import {BreadcrumbModule} from '../breadcrumb/breadcrumb.module';
import {OptionalLinkModule} from '../optional-link/optional-link.module';
import {TitlePillComponent} from 'projects/common/components/header-wrapper/title-pill/title-pill.component';
import {EvaSubnavModule} from '@shopping-angular-components/eva-subnav';
import { HeaderView2Component } from './header-view-2/header-view-2.component';
import { TranslateModule } from '@ngx-translate/core';
import { EvaButtonModule } from '../eva-button/eva-button.module';
import { HeaderView1Component } from './header-view-1/header-view-1.component';
import { HeaderView3Component } from './header-view-3/header-view-3.component';
import { HeadingAppComponent } from './heading-app/heading-app.component';
import { DualPromoModule } from '../offers/dual-promo/dual-promo.module';
import { ReviewScoreModule } from '../review-score/review-score.module';
import { HeadingVideoComponent } from './heading-video/heading-video.component';
import { YoutubeEmbededVideoComponent } from '../youtube-embed/youtube-embeded-video.component';

@NgModule({
  declarations: [
    BackgroundHeaderComponent,
    HeaderWrapperComponent,
    HeaderView1Component,
    HeaderView2Component,
    HeaderView3Component,
    HeadingAppComponent,
    HeadingVideoComponent,
    TitlePillComponent,
    YoutubeEmbededVideoComponent
  ],
  imports: [
    CommonModule,
    MediaPictureModule,
    TagTextModule,
    SboxModule,
    MainTitleModule,
    BreadcrumbModule,
    OptionalLinkModule,
    EvaSubnavModule,
    EvaButtonModule,
    TranslateModule,
    DualPromoModule,
    ReviewScoreModule
  ],
  exports: [
    HeaderWrapperComponent,
    HeaderView1Component,
    HeaderView2Component,
    HeaderView3Component,
    HeadingVideoComponent,
    BackgroundHeaderComponent,
    TitlePillComponent,
    YoutubeEmbededVideoComponent
  ],
  providers: []
})
export class HeaderWrapperModule {
}
